import React from 'react';
import classes from './MenuIdeaComponent.module.scss'
import HangingTitle from "../../../containers/Home/MenuIdeaSection/Typography/HangingTitle";
import {withRouter} from "react-router-dom";

const MenuIdeaComponent = (props) => {

    const gotoDetail = (slug, paramTitle) => {
        // window.open("/menu-ideas-detail/" + slug);
        localStorage.setItem('menu_ideas:selected_detail', paramTitle);
        props.history.push("/menu-ideas-detail/" + slug);
    }

    return (
        <div key={props.data.id} className={classes.MenuIdeaCard_row}
             onClick={() => gotoDetail(props.data.slug, props.data.title)}>
            {/*<Link to={"/menu-ideas-detail/" + props.data.id}>*/}
            <div className={classes.MenuIdeaCard_component}>
                <div className={classes.MenuIdeaCard_image}>

                    <div className={classes.MenuIdeaCard_bgImage} style={{backgroundImage: `url(${props.data.thumbnail_image})`}}/>

                    {/*<img src={props.data.thumbnail_image} alt={props.data.title}/>*/}
                </div>
                <HangingTitle title={props.data.title} type={'idea'} textLength={props.textLength}/>
            </div>
            {/*</Link>*/}
        </div>
    );
}

export default withRouter(MenuIdeaComponent);